export async function generateId(
  prefix: string,
  length: number,
): Promise<string> {
  const { customAlphabet } = await import('nanoid')
  const nanoid = customAlphabet('1234567890ABCDEFGHIJKLMNOPQRSTUVWXYZ', length)
  return `${prefix}-${nanoid()}`
}
